<template>
  <div class="bimetallic-strip-viz">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ΔL = α · L₀ · ΔT$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="2" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
             </filter>
          </defs>

          <!-- The Strip (Two layers) -->
          <g :transform="`translate(50, 120)`">
             <!-- Metal A - High Expansion (e.g. Brass) -->
             <path :d="upperPath" fill="#ffd700" stroke="#b8860b" filter="url(#glow)" />
             <!-- Metal B - Low Expansion (e.g. Invar) -->
             <path :d="lowerPath" fill="#aaa" stroke="#888" />
             <text x="10" y="-15" fill="#ffd700" font-size="8">金属 A (高膨胀系数 α1)</text>
             <text x="10" y="25" fill="#aaa" font-size="8">金属 B (低膨胀系数 α2)</text>
          </g>

          <!-- Contact Switch -->
          <g transform="translate(300, 80)">
             <circle r="6" :fill="isContact ? '#2ed573' : '#444'" filter="url(#glow)" />
             <text x="10" y="5" fill="#888" font-size="10">自动控温触点</text>
          </g>

          <!-- Flame indicator -->
          <g v-if="temp > 50" transform="translate(150, 180)">
             <path d="M -15,0 Q 0,-40 15,0 Z" fill="#ff4757">
                <animate attributeName="opacity" values="0.4;0.9;0.4" dur="0.6s" repeatCount="indefinite" />
             </path>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>当前温度 T</label>
              <div class="value">{{ temp }} °C</div>
           </div>
           <div class="stat">
              <label>状态反馈</label>
              <div class="value" :style="{ color: isContact ? '#2ed573' : '#ff4757' }">{{ isContact ? '电路已断开 (过热保护)' : '电路正常工作中' }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <label>环境温度调节</label>
           <el-slider v-model="temp" :min="0" :max="100" size="mini"></el-slider>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>由于金属 A 的线膨胀系数大于金属 B，在受热时 A 侧伸长量更大。当两者被牢固结合在一起时，金属片整体会向膨胀系数较小的一侧（即下方）弯曲。这种性质常用于电熨斗、温控开关等自动控制设备。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BimetallicStripViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 20
    }
  },
  computed: {
    bend() { return (this.temp - 20) * 0.8; },
    isContact() { return this.bend > 40; },
    upperPath() {
       let b = this.bend;
       return `M 0,0 L 200,0 Q 200,${b} 200,${b+5} L 0,10 Z`;
    },
    lowerPath() {
       let b = this.bend;
       return `M 0,10 L 200,${b+5} Q 200,${b+10} 200,${b+15} L 0,20 Z`;
    }
  }
}
</script>

<style scoped lang="scss">
.bimetallic-strip-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 16px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.hud-top { 
  position: absolute; top: 0; width: 100%; padding: 20px; display: flex; gap: 15px;
  .stat { background: rgba(255,255,255,0.03); backdrop-filter: blur(8px); padding: 8px 15px; border-radius: 8px; border-left: 3px solid #ffd700; }
}
.bottom-controls { padding: 0 20px 20px; display: flex; flex-direction: column; gap: 12px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 15px 20px; border-radius: 12px; border: 1px solid rgba(255, 71, 87, 0.1); 
  p { margin: 0; font-size: 0.85rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
